module.exports = __webpack_public_path__ + "static/media/1_Quotes.70939aaa.png";